/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Call activity for a single tool on an unproxied MCP server
 */
export type UnproxiedMcpServerToolUsageRow = {
  /**
   * Number of observed calls to this tool
   */
  callCount: number;
  /**
   * Number of observed calls that errored
   */
  failureCount: number;
  /**
   * The tool's name
   */
  toolName: string;
};

/** @internal */
export const UnproxiedMcpServerToolUsageRow$inboundSchema: z.ZodMiniType<
  UnproxiedMcpServerToolUsageRow,
  unknown
> = z.pipe(
  z.object({
    call_count: z.int(),
    failure_count: z.int(),
    tool_name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "call_count": "callCount",
      "failure_count": "failureCount",
      "tool_name": "toolName",
    });
  }),
);

export function unproxiedMcpServerToolUsageRowFromJSON(
  jsonString: string,
): SafeParseResult<UnproxiedMcpServerToolUsageRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UnproxiedMcpServerToolUsageRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UnproxiedMcpServerToolUsageRow' from JSON`,
  );
}
